var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "User Scanning",
    xmlns: "http://www.w3.org/2000/svg",
    width: "25px",
    height: "25px",
    viewBox: "0 0 94.398 94.062",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13679",
    d: "M7.871 17.83a4.026 4.026 0 0 0-3.985-3.78 3.865 3.865 0 0 0-3.878 4.1C1.68 43.3 9.887 51.507 35.038 53.178a3.865 3.865 0 0 0 4.1-3.878 4.026 4.026 0 0 0-3.78-3.986 71.026 71.026 0 0 1-10.479-1.384c-5.334-1.185-8.5-2.924-10.6-5.024s-3.838-5.265-5.024-10.6A71.033 71.033 0 0 1 7.871 17.83z",
    transform: "translate(0 40.875)",
    style: {
      fill: "#abafd1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13680",
    d: "M45.229 17.83a4.026 4.026 0 0 1 3.986-3.78 3.865 3.865 0 0 1 3.878 4.1c-1.672 25.15-9.88 33.357-35.031 35.028a3.865 3.865 0 0 1-4.1-3.878 4.026 4.026 0 0 1 3.78-3.986 71.034 71.034 0 0 0 10.479-1.384c5.334-1.185 8.5-2.924 10.6-5.024s3.838-5.265 5.024-10.6a71.035 71.035 0 0 0 1.384-10.476z",
    transform: "translate(40.96 40.875)",
    style: {
      fill: "#abafd1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13681",
    d: "M24 12.359z",
    transform: "translate(70.398 34.853)",
    style: {
      fill: "#abafd1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13682",
    d: "M53.092 35.125a3.865 3.865 0 0 1-3.878 4.1 4.026 4.026 0 0 1-3.986-3.78 71.027 71.027 0 0 0-1.385-10.477c-1.185-5.334-2.924-8.5-5.024-10.6s-5.265-3.838-10.6-5.024a71.026 71.026 0 0 0-10.475-1.387 4.026 4.026 0 0 1-3.78-3.985 3.865 3.865 0 0 1 4.1-3.878c25.149 1.672 33.357 9.879 35.028 35.031z",
    transform: "translate(40.96 -.086)",
    style: {
      fill: "#abafd1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13683",
    d: "M7.871 35.442a4.026 4.026 0 0 1-3.985 3.78 3.865 3.865 0 0 1-3.878-4.1C1.68 9.973 9.887 1.766 35.038.094a3.865 3.865 0 0 1 4.1 3.878 4.026 4.026 0 0 1-3.78 3.985 71.022 71.022 0 0 0-10.479 1.386c-5.334 1.185-8.5 2.924-10.6 5.024s-3.838 5.265-5.024 10.6a71.025 71.025 0 0 0-1.384 10.475z",
    transform: "translate(0 -.086)",
    style: {
      fill: "#abafd1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13684",
    d: "M9 16.886a11.8 11.8 0 1 0 11.8-11.8A11.8 11.8 0 0 0 9 16.886zm7.866 0a3.933 3.933 0 1 0 3.934-3.933 3.933 3.933 0 0 0-3.934 3.933z",
    transform: "translate(26.398 14.581)",
    style: {
      fill: "#6610f2",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13685",
    d: "M6 23.886c0 9.717 4.165 11.8 23.6 11.8s23.6-2.083 23.6-11.8-4.165-11.8-23.6-11.8S6 14.169 6 23.886zm7.866 0a11.03 11.03 0 0 0 .209 2.53 15.173 15.173 0 0 0 4.507.974 104.716 104.716 0 0 0 11.017.429 104.718 104.718 0 0 0 11.017-.429 15.17 15.17 0 0 0 4.507-.974 11.006 11.006 0 0 0 .209-2.53 11.006 11.006 0 0 0-.209-2.53 15.17 15.17 0 0 0-4.507-.974 104.718 104.718 0 0 0-11.016-.429 104.717 104.717 0 0 0-11.017.429 15.174 15.174 0 0 0-4.507.974 11.03 11.03 0 0 0-.21 2.53z",
    transform: "translate(17.599 35.114)",
    style: {
      fill: "#6610f2",
      fillRule: "evenodd"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.cb5ecf3788929445df2bed65e0543029.svg";
export { ForwardRef as ReactComponent };